import { Component } from "react";
import googleBadge from "./../../images/greyscale-short.svg";

export default class GoogleTranslateAttributionBadge extends Component {
  render() {
    return (
      <a href="//translate.google.com" target="_blank" rel="noopener noreferrer">
        <img src={googleBadge} alt="translated by Google" />
      </a>
    );
  }
}
